<template>
  <div class="th_info">
    <div class="th_info_top">
      {{$t("main.text309")}}
      <div class="th_info_button" @click="download_pdf">
        {{ $t("main.text783") }}
      </div>
    </div>
    <div class="th_info_main">
      <div class="th_tit1">{{ $t("main.text309") }}</div>
      <div class="th_tit2">
        <div class="th_tit3">{{ $t("main.text310") }}</div>
        <div class="th_tit4">{{ overall_time(data_all.c_time) }}</div>
      </div>
      <div class="th_tit2">
        <!-- tx_type: 1加密货币 2法币 法币 那行为绿色文字 -->

        <div class="th_tit3" v-if="data_all.tx_type == 1">
          {{ $t("main.text326") }}
        </div>
        <div class="th_tit3" v-else>{{ $t("main.text326") }}</div>
        <div class="th_tit4">{{ data_all.tx_id }}</div>
      </div>

      <div class="th_tit1 title_bottom">{{ $t("main.text313") }}</div>
      <div class="th_tit2">
        <div class="th_tit3">{{ $t("main.text479") }}</div>
        <div class="th_tit4">
          <!-- 1 充值 2 提币 3转出到银行卡 4扣除年费 5扣除卡费 6扣除激活费 7退回年费 8退回卡费 9服务费 10 提币固定手续费 11 提币手续费 12 转出银行卡手续费 13 收益推荐费 -->
          <span v-if="data_all.type == 1">{{ $t("type.type1") }}</span>
          <span v-else-if="data_all.type == 2">{{ $t("type.type2") }}</span>
          <span v-else-if="data_all.type == 3">{{ $t("type.type3") }}</span>
          <span v-else-if="data_all.type == 4">{{ $t("type.type4") }}</span>
          <span v-else-if="data_all.type == 5">{{ $t("type.type5") }}</span>
          <span v-else-if="data_all.type == 6">{{ $t("type.type6") }}</span>
          <span v-else-if="data_all.type == 7">{{ $t("type.type7") }}</span>
          <span v-else-if="data_all.type == 8">{{ $t("type.type8") }}</span>
          <span v-else-if="data_all.type == 9">{{ $t("type.type9") }}</span>
          <span v-else-if="data_all.type == 10">{{ $t("type.type10") }}</span>
          <span v-else-if="data_all.type == 11">{{ $t("type.type11") }}</span>
          <span v-else-if="data_all.type == 12">{{ $t("type.type12") }}</span>
          <span v-else-if="data_all.type == 13">{{ $t("type.type13") }}</span>
          <span v-else-if="data_all.type == 14">{{ $t("type.type14") }}</span>
          <span v-else-if="data_all.type == 15">{{ $t("type.type15") }}</span>
          <span v-else-if="data_all.type == 16">{{ $t("type.type16") }}</span>
          <span v-else-if="data_all.type == 17">{{ $t("type.type17") }}</span>
          <span v-else-if="data_all.type == 18">{{ $t("type.type18") }}</span>
          <span v-else-if="data_all.type == 19">{{ $t("type.type19") }}</span>
          <span v-else-if="data_all.type == 20">{{ $t("type.type20") }}</span>
          <span v-else-if="data_all.type == 21">{{ $t("type.type21") }}</span>
          <span v-else-if="data_all.type == 22">{{ $t("type.type22") }}</span>
          <span v-else-if="data_all.type == 23">{{ $t("type.type23") }}</span>
          <span v-else-if="data_all.type == 24">{{ $t("type.type24") }}</span>
          <span v-else-if="data_all.type == 25">{{ $t("type.type25") }}</span>
          <span v-else-if="data_all.type == 26">{{ $t("type.type26") }}</span>
          <span v-else-if="data_all.type == 27">{{ $t("type.type27") }}</span>
          <span v-else-if="data_all.type == 28">{{ $t("type.type28") }}</span>
          <span v-else>-</span>
          <!-- &nbsp;&nbsp;<span>{{data_all.card_username||"-" }}</span> -->
        </div>
      </div>

      <div class="th_tit2">
        <div class="th_tit3">{{ $t("bank_card.card_username") }}</div>
        <div class="th_tit4">{{ data_all.card_username || "-" }}</div>
      </div>

      <div class="th_tit2">
        <div class="th_tit3">{{ $t("main.text282") }}</div>
        <div class="th_tit4">{{ data_all.token_type }}</div>
      </div>
      <div class="th_tit2">
        <div class="th_tit3">{{ $t("main.text701") }}</div>
        <div class="th_tit4">{{ data_all.to_token_type }}</div>
      </div>
      <div class="th_tit2">
        <div class="th_tit3">{{ $t("main.text314") }}</div>
        <div class="th_tit4">
          {{ set_num3(data_all.amount) }} {{ data_all.token_type }}
        </div>
      </div>
      <div class="th_tit2">
        <div class="th_tit3">{{ $t("main.text793") }}</div>
        <div class="th_tit4">
          {{
            data_all.receive == "-"
              ? data_all.receive
              : set_num3(data_all.receive)
          }}
        </div>
      </div>
      <div class="th_tit2" v-if="data_all.tx_type == 1">
        <!-- tx_type: 1加密货币 2法币 -->
        <!-- 加密货币充值 才会有这个 字段   法币充值 不需要有 sender sddress -->
        <div class="th_tit3">{{ $t("main.text315") }}</div>
        <div class="th_tit4">{{ data_all.from_addr }}</div>
      </div>
      <div class="th_tit2">
        <div class="th_tit3">{{ $t("main.text316") }}</div>
        <div class="th_tit4">
          <!-- 状态: 20 成功 21 审核中 22 审核失败; 23交易中；24交易失败 25 待审核 -->
          <span v-if="data_all.status == 20">{{ $t("main.text317") }}</span>
          <span v-else-if="data_all.status == 21">{{
            $t("main.text318")
          }}</span>
          <span v-else-if="data_all.status == 22">{{
            $t("main.text319")
          }}</span>
          <span v-else-if="data_all.status == 23">{{
            $t("main.text320")
          }}</span>
          <span v-else-if="data_all.status == 24">{{
            $t("main.text321")
          }}</span>
          <span v-else-if="data_all.status == 25">{{
            $t("main.text229")
          }}</span>
          <span v-else>-</span>
        </div>
      </div>
      <div class="th_tit2">
        <div class="th_tit3">{{ $t("bank_card.card_number") }}</div>
        <div class="th_tit4">{{ data_all.card_number }}</div>
      </div>
      <div class="th_tit2">
        <div class="th_tit3">{{ $t("main.text735") }}</div>
        <div class="th_tit4" v-if="data_all.remark">{{ data_all.remark }}</div>
        <div class="th_tit4" v-else>-</div>
      </div>
    </div>
    <div class="download_pdf_box pdf_location">
      <PDF4 :dataList="pdf4List" :y="y" :m="m" :days="days" />
      <div class="pdf-header">
        <div class="pdf-header1">
          <img src="../../assets/img/pdf_logo.png" alt="" />
        </div>
        <div class="pdf-header3">
          <div>
            <template v-if="pdf4List.type == 1||pdf4List.type == 22||pdf4List.type == 27">
              <span class="header-title" v-if="v_lan == 'ch'">{{
                $t("main.text784")
              }}</span>
              <span class="header-title" style="line-height: 28px">{{
                lang_en.main.text784
              }}</span>
            </template>
            <!-- <template v-if="pdf4List.type == 2 || pdf4List.type == 10 || pdf4List.type == 11"> -->
            <!-- <template v-if="pdf4List.type != 1"> -->
            <template v-else>
              <span class="header-title" v-if="v_lan == 'ch'">{{
                $t("pdf.text59")
              }}</span>
              <span class="header-title" style="line-height: 30px">{{
                lang_en.pdf.text59
              }}</span>
            </template>
            <span class="sub-title"
              >{{ pdf4List.company_name }}-{{ pdf4List.account_number }}-{{
                pdf4List.token_type
              }}</span
            >
          </div>
        </div>
      </div>
      <div class="pdf-footer">
        <div class="pdf-footer-div" style="padding-top: 5px">
          <div class="left">
            <p>
              <span v-if="v_lan == 'ch'">{{ $t("pdf.text41") }}</span>
              <span>{{ lang_en.pdf.text41 }}</span> :
              <span>{{ downTime }}</span>
            </p>
            <p>
              <span v-if="v_lan == 'ch'">{{ $t("pdf.text42") }}</span>
              <span>{{ lang_en.pdf.text42 }}</span> :
              <span>{{ username }}</span>
            </p>
          </div>
          <div class="right">
            <p>
              <span v-if="v_lan == 'ch'">{{ $t("pdf.text47") }}</span>
              <span>{{ lang_en.pdf.text47 }}</span> 1 of 1
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { transaction_get, detailsStatement } from "@/api/api";
import PDF4 from "../pdf/pdf4.vue";
import lang_en from "@/language/en";
import { outputPDF } from "@/utils/outputPDF";

export default {
  filters: {
    current_month(v) {
      let en_mon_arr = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      return en_mon_arr[v - 1];
    },
  },
  components: {
    PDF4,
  },
  data() {
    return {
      lang_en: lang_en,
      info_hash_tx_id: "",
      info_id: "",
      data_all: "",
      pdf4List: {},
      typeMap: {
        1: "存款单",
      },
      en_mon_arr: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      username: "",
      downTime: "",
      y: "",
      m: "",
      days: "",
    };
  },
  created() {
    this.info_hash_tx_id = sessionStorage.getItem("my_info_tx_id");
    this.info_id = sessionStorage.getItem("my_info_id");
  },
  beforeDestroy() {
    sessionStorage.removeItem("top_title_name");
    sessionStorage.removeItem("my_info_id");
  },
  mounted() {
    sessionStorage.setItem(
      "top_title_name",
      this.info_hash_tx_id == "-" ? "" : this.info_hash_tx_id
    );
    this.get_list();
    this.username = sessionStorage.getItem("username");
  },
  methods: {
    get_list() {
      transaction_get({ id: this.info_id }).then((res) => {
        if (res.data.code == 200) {
          this.data_all = res.data.data;
          // console.log(res.data.data);
        }
      });
    },
    async download_pdf() {
      const that = this;
      let now = new Date();
      let utc = now.getTimezoneOffset() / -60;
      that.downTime = `${now.getDate()}-${
        that.en_mon_arr[now.getMonth()]
      }-${now.getFullYear()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}(GMT +${utc})`;
      await detailsStatement({ id: this.info_id }).then((res) => {
        if (res.data.code == 200) {
          // type
          // tx_type: 1加密货币 2法币
          that.pdf4List = res.data.data;
          let date = new Date(that.pdf4List.date);
          that.y = date.getFullYear();
          that.m = date.getMonth() + 1;
          that.days = date.getDate();
        }
      });
      const element = document.querySelector(".download_pdf_box");
      const header = document.querySelector(".pdf-header");
      const footer = document.querySelector(".pdf-footer");
      try {
        await outputPDF({
          element: element,
          footer: footer,
          header: header,
          contentWidth: 560,
        });
      } catch (error) {
        this.$message.error(
          typeof error === "string" ? error : JSON.stringify(error)
        );
      }
    },
  },
};
</script>

<style scoped>
.th_info {
  background: #314b69;
  border-radius: 16px;
}
.th_info_top {
  box-sizing: border-box;
  padding: 28px;
  border-bottom: 1.5px solid #041e35;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.th_info_top .th_info_button {
  padding: 2px 24px;
  font-size: 14px;
  border-radius: 4px;
  color: #deb981;
  border: 1.5px solid #deb981;
  background: transparent;
  cursor: pointer;
}
.th_info_main {
  box-sizing: border-box;
  padding: 28px;
}
.th_tit1 {
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  margin-bottom: 12px;
}
.th_tit2 {
  margin-bottom: 12px;
  display: flex;
}
.th_info_main .th_tit2:last-child {
  margin-bottom: 0;
}
.th_tit3 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.6);
  width: 160px;
  margin-right: 28px;
  display: inline-block;
}
.th_tit4 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  display: inline-block;
}
.title_bottom {
  margin-top: 30px;
}
.pdf_location {
  color: #000;
  position: fixed;
  top: 0;
  left: 0;
  transform: translateX(-100%);
  background: #fff;
  z-index: 2;
  width: 900px;
}
</style>
<style lang="less" scoped>
.pdf-footer {
  width: 1000px;
  position: fixed;
  background: #fff;
  top: -100vh;

  .pdf-footer-div {
    border: 1px solid #000;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 5px;
    display: flex;
    justify-content: space-between;
    margin: 20px 60px;
    font-weight: 400;
    font-size: 12px;
    color: #000000;
  }
}
.pdf-header {
  width: 1000px;
  position: fixed;
  top: -100vh;
  display: flex;
  justify-content: space-between;
  .pdf-header1 {
    margin: 20px 60px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    img {
      width: 150px;
    }
  }
  .pdf-header3 {
    margin-top: 20px;
    margin-right: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    div {
      display: flex;
      flex-direction: column;
      .header-title {
        font-size: 24px;
        font-family: "PingFang", "Outfit-SemiBold", "Outfit-Medium";
        font-weight: 600;
        color: #000000;
      }
      span {
        text-align: right;
      }
      .sub-title {
        margin-top: 16px;
        font-family: "Outfit-Light";
        font-size: 12px;
        font-weight: 300;
        color: #000000;
      }
    }
  }
}
</style>